import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { Dashboard, Dashboards } from '../../types';

export class DashboardAppBaseDataProvider extends BaseWebComponentDataProvider {
  async createDashboard(): Promise<Dashboard | null> {
    throw new Error('Needs to be implemented');
  }

  async initDashboards(): Promise<Dashboards> {
    throw new Error('Needs to be implemented');
  }
}
